var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    [
      _c("RatioContainer", { staticClass: "room-info-icon" }, [
        _c("div", { staticClass: "outline" }, [
          !!_vm.imageUrl
            ? _c("img", { attrs: { src: _vm.imageUrl } })
            : _vm._e()
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }